import { render, staticRenderFns } from "./register.vue?vue&type=template&id=340bf00c&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&id=340bf00c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340bf00c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('340bf00c')) {
      api.createRecord('340bf00c', component.options)
    } else {
      api.reload('340bf00c', component.options)
    }
    module.hot.accept("./register.vue?vue&type=template&id=340bf00c&scoped=true&", function () {
      api.rerender('340bf00c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginPublic/register.vue"
export default component.exports